import { Component, OnInit, Inject, Output, EventEmitter, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { CreatePermissionViewModel } from 'src/app/viewModels/permissions/createPermissionViewModel/create-permission-view-model';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { PermissionService } from '../services/permission/permission.service';

@Component({
  selector: 'app-create-permissions',
  templateUrl: './create-permissions.component.html',
  styleUrls: ['./create-permissions.component.scss']
})
export class CreatePermissionsComponent implements OnInit,AfterViewChecked {
  OfficeIDList: any=[];
  @ViewChild('permissionName', {static: true}) permissionName:ElementRef;
  myOfficeID: any;
  constructor(private fb: FormBuilder, private permissionService: PermissionService,
    private toastr: ToastrService, private statusConst: StatusConstant,
    private paginationVM: PaginationViewModel, private loaderService: LoaderService,
    private loader: LoaderService, private createPermissionVM: CreatePermissionViewModel,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private router: Router, private constant: Constants) {
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
      
      const encryptedtoken = sessionStorage.getItem('userToken');
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);

    this.createPermissionform = this.fb.group({
      permissionName: ['', Validators.required],
      permissionDescription: ['', Validators.required],
      isActive: '',
      moduleSelected: ['', Validators.required],
      permissionAdd: [''],
      permissionEdit: [''],
      permissionDelete: ['']
    });
  }

  
  dataSource;
  displayedColumns = ['PermissionName', 'PermissionDescription', 'permissionApplied'];
  createPermissionform: FormGroup;
  createPermissionResponseHolder: any;
  permissionListArray: any[] = [];
  permissionApplied = new FormControl();
  ModuleListResponseHolder: any;
  ModuleList: any;
  moduleSelected: any;
  currentUser: any;
  @Output() closeSidePanel = new EventEmitter();
  
  databaseId: string;
  organizationId: string;

  ngOnInit(): void {
    this.permissionName.nativeElement.focus();
    this.paginationVM.pageIndex = 1; 
    this.permissionListArray.push(this.constant.Edit);
    this.permissionListArray.push(this.constant.Add);
    this.permissionListArray.push(this.constant.Delete);
    this.getModuleList();
  }

  ngAfterViewChecked(){
    // setTimeout(() => {
    //   this.permissionName.nativeElement.focus();
    // }, 1);
  }

  getModuleList() {
    let pagesize = this.paginationVM.pageSize;
    this.paginationVM.pageSize = 10000;
    this.paginationVM.OfficeIDList=this.OfficeIDList;  
    this.loaderService.show();
    this.permissionService.getModuleList(this.paginationVM).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.ModuleListResponseHolder = response;
        this.ModuleList = this.ModuleListResponseHolder.data;        
      }else{
        this.loaderService.hide();
      }
    });
    this.paginationVM.pageSize= pagesize;
  }

  createPermission(formValues) {
    if (formValues != undefined) {
      this.loader.show();
      this.createPermissionVM.permissionName = formValues.permissionName;
      this.createPermissionVM.description = formValues.permissionDescription;
      this.createPermissionVM.moduleId = formValues.moduleSelected;
      this.createPermissionVM.createdBy = this.currentUser.UID;
      this.createPermissionVM.organizationID=Number(this.organizationId); 
      this.createPermissionVM.officeID=this.myOfficeID ;  
      if (formValues.permissionAdd == true) {
        this.createPermissionVM.addPermission = true;
      }
      else {
        this.createPermissionVM.addPermission = false;
      }

      if (formValues.permissionEdit == true) {
        this.createPermissionVM.editPermission = true;
      }
      else {
        this.createPermissionVM.editPermission = false;
      }

      if (formValues.permissionDelete == true) {
        this.createPermissionVM.deletePermission = true;
      }
      else {
        this.createPermissionVM.deletePermission = false;
      }

      this.permissionService.createPermission(this.createPermissionVM).subscribe(response => {
        if (response) {
          this.createPermissionResponseHolder = response;
          this.loader.hide();
          if (this.createPermissionResponseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success("Permission created successfully.", '', {
              timeOut: 3000,
            });
          }
          else {
            this.toastr.error(this.createPermissionResponseHolder.message, '', {
              timeOut: 3000,
            });
          }
          this.createPermissionform.reset();
          let closePanel = true;
          this.closeSidePanel.emit(closePanel);       
        }
      });      
    }
  }

  close() {
    let closePanel = false;
    this.createPermissionform.reset();
    this.closeSidePanel.emit(closePanel);
  }

}
